import { BASE_IDENTITY } from '@http';
import { AxiosInject, getUserToken } from '@utils';
import { store } from '@store/store';
import { findWlData } from '@src/utils/whiteLabel';

const WL_KEY_FALLBACK = 'siswamedia';

function pickWhiteLabelKey(value) {
  if (value == null) return '';
  const s = String(value).trim();
  return s || '';
}

/**
 * Resolve white_label_key for notification token register/revoke/refresh.
 *
 * Priority:
 *  1. GET /v2/schools/{id} → data.white_label_key (school-scoped, from login/switch)
 *  2. Legacy General.whitelabel config (domain bootstrap)
 *  3. Fallback "siswamedia"
 */
export function resolveNotificationWhiteLabelKey(state) {
  const schoolKey = pickWhiteLabelKey(
    state?.School?.schoolDetail?.white_label_key ?? state?.Class?.oneSchool?.white_label_key
  );
  if (schoolKey) return schoolKey;

  const wlRoot = state?.General?.whitelabel || [];
  return pickWhiteLabelKey(findWlData(wlRoot, 'white_label_key') || findWlData(wlRoot, 'site_key')) || WL_KEY_FALLBACK;
}

export function getNotificationWhiteLabelKey() {
  try {
    return resolveNotificationWhiteLabelKey(store.getState());
  } catch {
    return WL_KEY_FALLBACK;
  }
}

function getHttp() {
  return AxiosInject(BASE_IDENTITY, 'Bearer', getUserToken());
}

export async function registerNotificationToken(deviceToken) {
  const http = getHttp();
  const payload = {
    device_token: deviceToken,
    platform: 'web-pwa',
    white_label_key: getNotificationWhiteLabelKey(),
  };
  const resp = await http.post('v1/api/notifications/tokens', payload);
  return resp.data;
}

export async function revokeNotificationToken(deviceToken) {
  const http = getHttp();
  const payload = {
    device_token: deviceToken,
    white_label_key: getNotificationWhiteLabelKey(),
  };
  const resp = await http.delete('v1/api/notifications/tokens', { data: payload });
  return resp.data;
}

export async function refreshNotificationToken(oldDeviceToken, newDeviceToken) {
  const http = getHttp();
  const payload = {
    old_device_token: oldDeviceToken,
    new_device_token: newDeviceToken,
    platform: 'web-pwa',
    white_label_key: getNotificationWhiteLabelKey(),
  };
  const resp = await http.post('v1/api/notifications/tokens/refresh', payload);
  return resp.data;
}
